// extracted by mini-css-extract-plugin
export default {"phone":"599px","tabletPortrait":"600px","tabletLandscape":"900px","desktop":"1024px"};